<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1300px"
      unit="图片查看"
      id-key="UserId"
      in-dialog
      @close-saved="$emit('close-saved')"
    >
      <div class="demo-image">
        <div class="block" v-for="(item, index) in imgs" :key="'a'+index">
            <el-image
            style="width: 100px; height: 100px"
            :src="item"
            fit="fill"
            :preview-src-list="imgs"></el-image>
        </div>
    </div>

    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  props: {
    imgs: {
        type: Array,
        default: () => []
    }
  },

};
</script>

<style lang="scss" scoped>
    .demo-image{
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
    }

    .block{
        margin: 18px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100px;
        height: 100px;
    }
</style>
